import { Component, OnInit, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {TranslationService} from '../../services/translation.service';
import {ExFinancementRessource} from '../../../class/ex/ex-financement-ressource';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { NumberOnlyDirective } from '../../directives/numericNumberOnly';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-financement-ressource',
    template: `
        <h4 mat-dialog-title>{{ title|translate }}</h4>
        @if (financementRessource !== null) {
          <mat-dialog-content>
            <div class="row">
              <div class="col">
                <label for="organisme">{{'general.organisme'|translate}} : </label>
                <input
                  class="form-control"
                  type="text"
                  name="organisme"
                  required
                  id="organisme"
                  [(ngModel)]="financementRessource.organisme"
                  (input)="isButtonDisabled()"
                  />
                </div>
                <div class="col">
                  <label for="montantMensuelBrut"
                    >{{'general.montantMensuelBrut'|translate}} :</label
                    >
                    <input
                      class="form-control"
                      type="number"
                      min="0"
                      myNumberOnly
                      name="montantMensuelBrut"
                      id="montantMensuelBrut"
                      [(ngModel)]="financementRessource.montantMensuelBrut"
                      (input)="onNumberChange($event)"
                      />
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col">
                      <label for="periode">{{'fields.formFieldFinancementRessourcesList.periode'|translate}} :</label>
                      <input
                        class="form-control"
                        type="text"
                        name="periode"
                        id="periode"
                        [(ngModel)]="financementRessource.periode"
                        (input)="isButtonDisabled()"
                        />
                      </div>
                      <div class="col">
                        <label for="duree">{{'general.dureeMois'|translate}} :</label>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          name="duree"
                          id="duree"
                          myNumberOnly
                          [(ngModel)]="financementRessource.dureeMois"
                          (input)="onNumberChange($event)"
                          />
                        </div>
                      </div>
                      <br />
                    </mat-dialog-content>
                  }
                  <mat-dialog-actions>
                    <button mat-button [mat-dialog-close]="false">{{'general.annuler'|translate}}</button>
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="add()"
                      disabled="{{ !showAddButton }}"
                      >
                      {{'general.ajouter'|translate}}
                    </button>
                  </mat-dialog-actions>
        `,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, NumberOnlyDirective, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalFinancementRessourceComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalFinancementRessourceComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    private hydraService = inject(HydraService);
    translationService = inject(TranslationService);

    public title =
        'field.autresFinancements.modaleRessource.titre';
    public financementRessource: ExFinancementRessource = null;
    public showAddButton = false;

    constructor() {
        const data = this.data;

        if (
            data['financementRessource'] != undefined &&
            data['financementRessource'] != null
        ) {
            this.financementRessource = new ExFinancementRessource(
                data['financementRessource']
            );
        }
    }

    add() {
        if (
            (this.financementRessource.dureeMois != null &&
                this.financementRessource.dureeMois > 0) ||
            (this.financementRessource.organisme != null &&
                this.financementRessource.organisme.length) ||
            (this.financementRessource.montantMensuelBrut != null &&
                this.financementRessource.montantMensuelBrut > 0) ||
            (this.financementRessource.periode != null &&
                this.financementRessource.periode)
        ) {
            if (
                this.financementRessource.id == null ||
                this.financementRessource.id == undefined
            ) {
                delete this.financementRessource.position;
            }

            this.dialogRef.close(this.financementRessource);
        } else {
            this.dialogRef.close();
        }
    }

    isButtonDisabled() {
        if (
            this.financementRessource.dureeMois <= 0 &&
            !this.financementRessource.organisme &&
            this.financementRessource.montantMensuelBrut <= 0 &&
            !this.financementRessource.periode
        ) {
            this.showAddButton = false;
        } else {
            this.showAddButton = true;
        }
    }

    onNumberChange(event) {
        let min: number = null;
        let max: number = null;
        event.target.min ? (min = event.target.min) : null;
        event.target.max ? (max = event.target.max) : null;

        if (min && Number(event.target.value) < min) {
            event.target.value = '';
        } else if (max && Number(event.target.value) > max) {
            event.target.value = max;
        }

        this.isButtonDisabled();
    }

    ngOnInit() {}
}
